import React from 'react'

const Index = () => {
    return(
        <div className="tab-pane activities-tab fade show active" id="valg-aktivitet" role="tabpanel" aria-labelledby="activity-tab">
            <div className="tab-content-container">
                hei
            </div>
        </div>
    )
}

export default Index